import reportItems from "assets/js/widgetItems";
import {
  APP_RESET,
  CLOSE_MODAL,
  SET_ACTIVE_TAB,
  SET_ALERT,
  SET_BACK_URL,
  SET_CLOSE_ALL_REPORTS,
  SET_CONFIRM,
  SET_DISPLAY_ALERT,
  SET_EXPANDED_SIDEBAR,
  SET_FAVORITE_REPORTS,
  SET_FISCAL_YEAR,
  SET_FISCAL_YEARS,
  SET_FROM_DATE,
  SET_LOADING,
  SET_MODAL,
  SET_OPEN_ALL_REPORTS,
  SET_OPEN_DRAWER,
  SET_PAYMENT_DATA,
  SET_QUICK_ACCESS,
  SET_SECRET_VIEW,
  SET_SELECTED_REPORT_TYPE,
  SET_SENDING_REQUEST,
  SET_TABLE_COLUMNS,
  SET_TABLE_ORDER,
  SET_TO_DATE,
  SET_TOGGLE,
  SET_TOKEN,
  SET_USER,
  SET_WIDGETS,
  SET_GUIDE,
  SET_GUIDE_DATA,
  SET_DASHBOARD_GUIDE,
  SET_CREDIT_BALANCE,
  SET_APP_SETTINGS,
  SET_EXPANDED_NOTIFICATION,
  SET_IS_DEMO,
  SET_LABEL_SETTINGS, APP_FORCE_LOGOUT,
} from "../../constants/appConstants";
import { widgetConstants } from "constants/widgetConstants";
import { quickAccessConstant } from "constants/quickAccessConstants";

const initialState = {
  appSettings: [],
  quickAccess: quickAccessConstant,
  loading: false,
  toggle: false,
  modalShow: false,
  modalComponent: null,
  success: true,
  confirm: false,
  activeTab: "",
  backUrl: null,
  backData: null,
  alertType: null,
  alertMessage: null,
  alertDisplay: false,
  secretView: false,
  sendingRequest: false,
  requestingApi: null,
  paymentData: null,
  user: null,
  token: null,
  widgets: widgetConstants,
  favoriteReports: {
    title: "نشان شده ها",
    key: "pinned",
    subItems: [],
  },
  openReports: false,
  selectedReportType: 30,
  isDrawerOpen: false,
  drawerComponent: "",
  tableColumns: [],
  tableOrders: [],
  fromDate: null,
  toDate: null,
  sidebarExpanded: false,
  notificationExpanded: false,
  fiscalYears: [],
  fiscalYear: null,
  showGuide: false,
  guideData: [],
  showDashboardGuide: false,
  isDemo: false,
  creditBalance: 0,
  labelSettings: {},
  forceLogout: false,
};

const appReducer = (state = initialState, action) => {
  const { favoriteReports } = state;
  switch (action.type) {
    case APP_RESET:
      return {
        ...state,
        loading: false,
        toggle: false,
        // TODO: app reset does not let modals to be opened
        // modalShow: false,
        // modalComponent: null,
        favoriteReports: {
          title: "نشان شده ها",
          key: "pinned",
          subItems: [],
        },
        success: true,
        confirm: false,
        backUrl: null,
        backData: null,
        // alertType: null,
        // alertMessage: null,
        // alertDisplay: false,
        sendingRequest: false,
        paymentData: null,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case SET_TOGGLE:
      return {
        ...state,
        toggle: action.toggle,
      };
    case SET_MODAL:
      return {
        ...state,
        modalShow: action.show,
        modalProps: action.modalProps,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        modalShow: false,
      };
    case SET_SENDING_REQUEST:
      return {
        ...state,
        sendingRequest: action.sendingRequest,
        requestingApi: action.requestingApi,
      };
    case SET_ALERT:
      return {
        ...state,
        loading: false,
        confirm: false,
        sendingRequest: false,
        alertType: action.alertType,
        alertMessage: action.alertMessage,
        alertDisplay: action.alertDisplay,
      };
    case SET_DISPLAY_ALERT:
      return {
        ...state,
        alertDisplay: action.alertDisplay,
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };
    case SET_SECRET_VIEW:
      return {
        ...state,
        secretView: action.secretView,
      };
    case SET_BACK_URL:
      return {
        ...state,
        backUrl: action.backUrl,
        backData: action.backData ?? state.backData,
      };
    case SET_CONFIRM:
      return {
        ...state,
        confirm: action.title
          ? {
              title: action.title,
              action: action.action,
              callback: action.callback,
              message:action.message,
              ignoreAction:action.ignoreAction

            }
          : false,
      };
    case SET_PAYMENT_DATA:
      return {
        ...state,
        paymentData: action.paymentData,
      };
    case SET_TOKEN:
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    case SET_USER:
      return {
        ...state,
        loading: false,
        user: { ...state.user, ...action.user },
        token: action.user?.token ?? null,
      };
    case SET_QUICK_ACCESS:
      return {
        ...state,
        quickAccess: action.quickAccess,
      };
    case SET_WIDGETS:
      return {
        ...state,
        widgets: action.widgets,
      };
    case SET_FAVORITE_REPORTS:
      return {
        ...state,
        favoriteReports: {
          title: "نشان شده ها",
          key: "pinned",
          subItems: action.favoriteReports,
        },
      };
    case SET_OPEN_ALL_REPORTS:
      return {
        ...state,
        openReports: action.openReports,
      };
    case SET_CLOSE_ALL_REPORTS:
      return {
        ...state,
        openReports: action.openReports,
      };
    case SET_SELECTED_REPORT_TYPE:
      return {
        ...state,
        selectedReportType: action.selectedReportType,
      };
    case SET_OPEN_DRAWER:
      return {
        ...state,
        isDrawerOpen: action.open,
        drawerComponent: action.component,
        anchor: action.anchor,
        drawerProps: action.drawerProps,
      };
    case SET_TABLE_COLUMNS:
      return {
        ...state,
        tableColumns: action.payload,
      };
    case SET_TABLE_ORDER:
      return {
        ...state,
        tableOrders: action.payload,
      };
    case SET_FROM_DATE:
      return {
        ...state,
        fromDate: action.fromDate,
      };
    case SET_TO_DATE:
      return {
        ...state,
        toDate: action.toDate,
      };
    case SET_EXPANDED_SIDEBAR:
      return {
        ...state,
        sidebarExpanded: action.sidebarExpanded,
      };
    case SET_EXPANDED_NOTIFICATION:
      return {
        ...state,
        notificationExpanded: action.notificationExpanded,
      };
    case SET_FISCAL_YEARS:
      return {
        ...state,
        fiscalYears: action.fiscalYears,
      };
    case SET_FISCAL_YEAR:
      return {
        ...state,
        fiscalYear: action.fiscalYear,
      };

    case SET_GUIDE:
      return {
        ...state,
        showGuide: !state.showGuide,
      };
    case SET_GUIDE_DATA:
      return {
        ...state,
        guideData: action.list,
      };
    case SET_DASHBOARD_GUIDE:
      return {
        ...state,
        showDashboardGuide: action.value,
      };
    case SET_CREDIT_BALANCE:
      return {
        ...state,
        creditBalance: action.value,
      };
    case SET_APP_SETTINGS:
      return {
        ...state,
        appSettings: action.value,
      };
    case SET_IS_DEMO:
      return {
        ...state,
        isDemo: action.isDemo,
      };
    case SET_LABEL_SETTINGS:
      return {
        ...state,
        labelSettings: action.labelSettings,
      };
    case APP_FORCE_LOGOUT:
      return {
        ...state,
        forceLogout: action.force,
      };
    default:
      return state;
  }
};

export default appReducer;
